import { Share2, Star, Facebook, Instagram } from 'lucide-react'
import moment from 'moment/moment'
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import { A11y, Navigation, Pagination, Scrollbar } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { getVenueDetailsApi } from '../Utils/API'
import SportPriceModel from '../Models/SportPriceModel'
import { useDispatch, useSelector } from 'react-redux'
import { setBookingCourt } from '../Utils/Redux/sportSlice/sportSlice'
import Login from './Login'
import ShareContentModal from '../Models/ShareContentModal'
import RateVenueModal from '../Models/RateVenueModal'
import { images } from '../Utils/Images'


export default function Venue() {
    const location = useLocation()
    const data = location.state;
    const isLoggedIn = useSelector(state => state?.user?.isLoggedIn)
    const [priceModel, setPriceModel] = useState(false);
    const [selectedSport, setSelectedSport] = useState(null);
    const [venueDetails, setVenueDetails] = useState();
    const [ShareModal, setShareModal] = useState(false);
    const [VenueModal, setVenueModal] = useState(false);
    const [openLoginModal, setOpenLoginModal] = useState(false);
    const profileImages = venueDetails?.profile_image
    const rulesArray = venueDetails?.rules?.split('\n') // Split by new line
        ?.map(rule => rule?.replace('•', '').trim()) // Remove bullet and trim whitespace
        ?.filter(rule => rule);
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const handleBooking = () => {
        dispatch(setBookingCourt(venueDetails))
        isLoggedIn ? navigate(`/slot_booking?venueId=${venueDetails?.id}`, { state: { venueDetails } }) : setOpenLoginModal(true)
    };
    const openModel = (item) => {
        setSelectedSport(item); // Set the clicked sport
        setPriceModel(true); // Open the modal
    };
    const getDetails = async () => {
        try {
            await getVenueDetailsApi(data?.isBooking ? data?.internal_reference_id?.id : data?.id).then(res => {
                if (res?.data?.status == 'success') {
                    setVenueDetails(res?.data?.data)
                }
            })
        } catch (error) {
            console.log('error: ', error)
        }
    }

    const handleShareModal = () => setShareModal(true)
    const closeShareModal = () => setShareModal(false);


    useEffect(() => {
        window.scrollTo(0, 0);
        getDetails();
        dispatch(setBookingCourt(null))
    }, [])
    return (
        <>
            <div className='flex mx-4 lg:mx-20 pb-20'>
                <div className='grid w-full grid-cols-1 justify-items-center'>
                    <div className='w-full col-span-1 pb-10 px-2 md:px-0'>
                        <div className="mt-5">
                            <nav className="flex items-center flex-wrap text-gray-500 text-sm font-medium">
                                <a className="hover:text-primary hover:underline" href="/">Venues</a>
                                <span className="mx-2">&gt;</span>
                                <a className="hover:text-primary hover:underline" href="/">{venueDetails?.city}</a>
                                <span className="mx-2">&gt;</span>
                                <span>{venueDetails?.name}</span>
                            </nav>
                        </div>
                    </div>
                    <div className='w-full mt-2'>
                        <div className='flex flex-col justify-between w-full'>
                            <div className='grid w-full md:h-24 grid-flow-row-dense grid-cols-3 grid-rows-2 gap-y-1 md:gap-y-0 md:gap-x-5'>
                                <div className='w-full col-span-3'>
                                    <h1 className="md:font-bold md:text-[32px] md:leading-[36px] font-bold text-[24px] leading-[36px] text-typography overflow-hidden md:whitespace-nowrap whitespace-normal md:line-clamp-1 line-clamp-2 truncate">
                                        {data?.isBooking ? data?.internal_reference_id?.name : data?.name}
                                    </h1>
                                </div>
                                <div className='flex items-center w-full col-span-3 md:col-span-2'>
                                    <div className='flex flex-col w-full sm:items-start sm:justify-start'>
                                        <div className="text-[#515455] font-medium text-md">{venueDetails?.address}</div>
                                        <div className='flex flex-row mt-2 md:mt-3 sm:mr-8 sm:items-center sm:justify-center items-center'>
                                            <p className='mr-1 text-[#515455] text-sm font-semibold'>{data?.rating ? `${data?.rating} Ratings` : 'No Ratings'}</p>
                                            {/* <p className='text-sm text-[#515455] font-medium'>(4 Ratings)</p> */}
                                            <Star size={16} color='#FFD700' fill='#FFD700' />
                                            <p className="ml-2 text-sm font-semibold underline cursor-pointer text-primary" onClick={() => setVenueModal(true)}>Rate Venue</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex z-9 flex-row w-full col-span-3 mt-3 space-x-2 md:mt-0 sm:col-span-2 md:col-span-1'>
                                    <div className='flex flex-col items-center justify-end w-full space-y-3'>
                                        <button onClick={handleBooking} className="w-full h-12 px-3 py-2 font-semibold text-white rounded-lg bg-primary" alt="Book now Button" aria-label="Book Now">Book Now</button>
                                        <div className='flex flex-row items-center justify-start w-full space-x-2'>
                                            <button
                                                className="flex items-center justify-center w-full h-12 space-x-2 rounded-lg font-semibold text-black border-2 cursor-pointer"
                                                onClick={handleShareModal}
                                            >
                                                <Share2 />
                                                <span>Share</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='grid w-full grid-cols-1 gap-2 mt-6 md:gap-x-5 md:grid-cols-3'>
                            <div className=' w-full row-span-1 bg-opacity-50 md:block md:col-span-2'>
                                <div className="overflow-hidden min-w-60 aspect-video rounded-md w-full">
                                    <Swiper
                                        spaceBetween={50}
                                        slidesPerView={1}
                                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                                        navigation
                                        pagination={{ clickable: true }}
                                        onSlideChange={() => console.log('Slide changed')}
                                        onSwiper={(swiper) => console.log('Swiper instance:', swiper)}
                                        className="w-full h-full col-span-2"
                                    >
                                        {profileImages?.map((image) => (
                                            <SwiperSlide key={image?.id}>
                                                <img
                                                    src={image?.media_url}
                                                    alt={image?.media_name || 'Profile Image'}
                                                    className="w-full h-full object-cover bg-gray-100"
                                                />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </div>
                            <div className='w-full z-0 md:row-span-2'>
                                <div className='flex flex-col'>
                                    <div className='flex flex-col p-4 border border-gray-400 rounded-md'>
                                        <h2 className="font-semibold text-md md:text-lg">Timing</h2>
                                        <div className="mt-2 leading-1">
                                            {moment(venueDetails?.booking_opening_time, "HH:mm:ss").format("hh:mm A")} - {moment(venueDetails?.booking_closing_time, "HH:mm:ss").format("hh:mm A")}
                                        </div>
                                    </div>
                                    <div className='flex flex-col h-auto p-4 mt-5 border border-gray-400 rounded-md'>
                                        <div className="font-semibold text-md md:text-lg">Location</div>
                                        <h2 className="my-2">{venueDetails?.address}- {venueDetails?.pin_code}</h2>
                                        <div className='bg-primary font-semibold text-white px-3 py-1 rounded-full w-fit'>
                                            <a target="_blank" className='cursor-pointer' href={`${venueDetails?.google_map_url ? data?.google_map_url : "#"}`}>Location on Map</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='w-full rounded-lg md:row-span-5 md:col-span-2'>
                                <div className='p-6 mt-4 border border-gray-400 rounded-md'>
                                    <div className='flex flex-col justify-start md:items-center md:flex-row'>
                                        <h2 className="font-semibold text-md md:text-lg">Sports Available</h2>
                                        <div className="text-sm text-gray-500 md:ml-2">(Click on sports to view price chart)</div>
                                    </div>
                                    <div className='flex flex-row flex-wrap gap-4 items-center mt-5 border-gray-400 rounded-md'>
                                        {venueDetails?.sport_available_text?.map(item =>
                                            <div
                                                key={item?.id}
                                                onClick={() => openModel(item)}
                                                className='flex flex-col items-center justify-between py-2 border rounded shadow-md cursor-pointer hover:border-primary hover:border aspect-square border-border_color w-20'
                                            >
                                                <div>
                                                    <img src={item?.sport_image} alt={item?.sport_name} className='w-10 border rounded-full p-1 bg-gray-100 border-gray-300'/>
                                                </div>
                                                <h3 className='flex justify-center w-full text-xs font-medium text-center text-border_tag capitalize'>
                                                    {item?.sport_name}
                                                </h3>
                                            </div>
                                        )}
                                        <SportPriceModel open={priceModel} setIsOpen={setPriceModel} sportPrice={venueDetails?.sports_price} item={selectedSport} venueDetails={venueDetails} />
                                    </div>
                                </div>
                                <div className='flex flex-col mt-5 md:mt-5'>
                                    <div className='p-6 border border-gray-400 rounded-md'>
                                        <h3 className="font-semibold text-md">Amenities</h3>
                                        <div className='flex flex-row flex-wrap gap-4 items-center mt-5 border-gray-400 rounded-md'>
                                            {venueDetails?.available_amenities?.map(amenities =>
                                                <div className='flex flex-col border shadow-md rounded-md py-3 px-2 justify-between items-center text-sm capitalize md:text-md'>
                                                    <div className='border border-gray-300 p-1 mb-2 rounded-full overflow-hidden'>
                                                        <img src={amenities?.amen_image} alt={amenities?.amen_name} className='w-10 bg-gray-100 rounded-full' />
                                                    </div>
                                                    <h4 className=''>{amenities?.amen_name}</h4>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='w-full'>
                                    <div className='flex flex-col items-start w-full mt-5'>
                                        <div className='w-full p-5 border border-gray-400 rounded-md'>
                                            <div className="font-semibold text-md poi">Venue Rules</div>
                                            <ul className='list-disc list-inside mt-2'>
                                                {rulesArray?.map((rule, index) => (
                                                    <li key={index}>{rule}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Login openLoginModal={openLoginModal} setOpenLoginModal={setOpenLoginModal} fromBooking={true} />
            <ShareContentModal isOpen={ShareModal} onClose={closeShareModal} venueDetails={venueDetails} />
            <RateVenueModal isOpen={VenueModal} onClose={() => setVenueModal(false)} venueDetails={venueDetails} />
        </>

    )
}
